import { Carousel } from '@mantine/carousel'
import { Flex, Paper, Skeleton, Stack, Title, Box } from '@mantine/core'
import TitleDivider from './divider'
import NextSmallSVG from './buttons/next_carousel_button_small'
import PreviousSmallSVG from './buttons/previous_carousel_button_small'

const LiveStreamingCarousel = ({ isLoading }) => {
  if (isLoading) {
    return (
      <Flex sx={{ width: '100%' }} gap="1%">
        {[...Array(5)].map((_, index) => (
          <Skeleton height={120} width={800} key={index} />
        ))}
      </Flex>
    )
  }

  return (
    <Box mt={24}>
      <TitleDivider titleText="LIVESTREAMING CHANNELS" epgText="VIEW EPG" />
      <Carousel
        height={60}
        w={'100%'}
        mt={30}
        slideGap="20px"
        slideSize="21%"
        loop={false}
        align="start"
        slidesToScroll={5}
        nextControlIcon={<NextSmallSVG />}
        previousControlIcon={<PreviousSmallSVG />}
        styles={{
          control: {
            opacity: 10,
            cursor: 'default',
            backgroundColor: 'transparent',
            border: 'transparent',
            transform: 'none',
            transition: 'none',
            '&[data-inactive]': {
              opacity: 0,
              cursor: 'default'
            }
          }
        }}
      >
        {[...Array(4)].map((_, index) => (
          <Carousel.Slide key={index}>
            <Paper
              p={20}
              radius={4}
              h="100%"
              sx={{
                backgroundColor: '#0E1922'
              }}
            >
              <Stack space="sm" align="center" justify="space-between" h="100%">
                <Title
                  order={3}
                  sx={{
                    textAlign: 'center',
                    fontSize: '17px',
                    fontWeight: 'lighter'
                  }}
                >
                  CHANNEL NAME
                </Title>
              </Stack>
            </Paper>
          </Carousel.Slide>
        ))}
      </Carousel>
    </Box>
  )
}

export default LiveStreamingCarousel
